import { useEffect, useRef } from 'react'
import { useDispatch } from '../../../Flux/index.ts'
import { orderWizardActions as wizard } from '../../../Flux/Slice/OrderWizard/OrderWizardSlice.ts'
import type { DraftState } from '../../../Model/OrderWizard/OrderWizardDraft.ts'
import type { SequencingPlatformKey } from '../../../Generated/SequencingPlatform.ts'

/** The review's dispatches, and its reaction to a refused submit: the issue list opens. */
export const useReviewSession = (draft: DraftState, onShowIssues: () => void) => {
  const dispatch = useDispatch()
  const refusals = draft.submitFlow?.refusals ?? 0
  const refusalsSeen = useRef(refusals)
  useEffect(() => {
    if (refusals > refusalsSeen.current) {
      onShowIssues()
    }
    refusalsSeen.current = refusals
  }, [refusals, onShowIssues])

  return {
    retry: () => dispatch(wizard.reviewRequested({ draftId: draft.id })),
    override: (platform: SequencingPlatformKey | null) => dispatch(wizard.platformOverrideRequested({ draftId: draft.id, platform })),
    submit: () => dispatch(wizard.submitRequested({ draftId: draft.id }))
  }
}
